export enum StreamChannelType {
  Team = "team",
  DirectMessage = "messaging",
}

export const streamChannelTypes = Object.freeze([
  StreamChannelType.Team,
  StreamChannelType.DirectMessage,
]);
